import {BaseOptions} from "../../../../dialog/options/base.options";

export class AddOrUpdateCategoryOptions extends BaseOptions {
  category?: any;

  onInsertOrUpdateFinished() {
  }
}
